<template>
  <div>
    <h4>{{ $t("login") }}</h4>
    <p class="widget-auth-info mb-n5">
      {{ $t("useYourEmailToLogin") }}
    </p>
    <login-form :redirect-url="destination" />
    <p class="widget-auth-info">
      <router-link to="/password-reset">{{ $t("forgotPassword") }}</router-link>
    </p>
  </div>
</template>

<script>
import LoginForm from "@/components/LoginAdForm.vue";

export default {
  name: "LoginFormAdView",
  components: {
    LoginForm
  },
  data() {
    return {
      destination: this.$route.query.nextUrl ? this.$route.query.nextUrl : "/home"
    };
  },
  mounted() {}
};
</script>

<style scoped lang="scss"></style>
